import {SET_TOP_DATA} from "./actionTypes";

const initialState = {
	data: null
};

export const topReducer = (state = initialState, action) => {
	state = {...state}
	switch (action.type) {
		case SET_TOP_DATA:
			state.data = action.payload
			break;


	}

	return state;
};
